(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(function (root) {
  'use strict';
  const CAMPAIGN = 'nhs_home_staging_search_pilot';
  const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid'];
  const MAX_AGE = 30 * 60 * 1000;
  function attribution(search) {
    const params = new URLSearchParams(search || '');
    return Object.fromEntries(KEYS.map(key => [key, (params.get(key) || '').replace(/[\r\n\u0000-\u001f]/g, '').slice(0, key.endsWith('braid') || key === 'gclid' ? 512 : 200)]));
  }
  function pendingRecord(raw, now, path) {
    try {
      const value = JSON.parse(raw);
      if (!value || !/^nhs-[a-zA-Z0-9-]{8,80}$/.test(value.id) || value.path !== path || !Number.isFinite(value.created) || now < value.created || now - value.created > MAX_AGE) return null;
      return value;
    } catch (_) { return null; }
  }
  const core = { CAMPAIGN, KEYS, MAX_AGE, attribution, pendingRecord };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (!root || !root.document) return;
  
  function init(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const form = container.closest('form');
    if (!form) return;
    const preview = container.dataset.preview === 'true' || Boolean(root.Shopify && root.Shopify.designMode) || new URLSearchParams(root.location.search).has('preview_theme_id');
    const test = container.dataset.test === 'true' || new URLSearchParams(root.location.search).get('nhs_test') === '1';
    const key = 'nhs-staging-pending:' + root.location.pathname;
    const get = k => { try { return root.sessionStorage.getItem(k); } catch (_) { return null; } };
    const set = (k,v) => { try { root.sessionStorage.setItem(k,v); } catch (_) {} };
    const remove = k => { try { root.sessionStorage.removeItem(k); } catch (_) {} };
    const field = name => form.elements.namedItem('contact[' + name + ']');
    const put = (name,value) => { if (field(name)) field(name).value = value; };
    const id = 'nhs-' + (root.crypto && root.crypto.randomUUID ? root.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
    put('Lead ID', id);
    put('Campaign', CAMPAIGN);
    put('Submission type', test || preview ? 'TEST' : 'LIVE');
    const tags = attribution(root.location.search);
    KEYS.forEach(name => put(name, tags[name]));
    let confirmed = null;
    let conversionQueued = false;
    let tagStarted = false;
    const enabled = !test && !preview;
    function adsCommand() {
      root.nhsAdsDataLayer = root.nhsAdsDataLayer || [];
      root.nhsAdsDataLayer.push(arguments);
    }
    function syncMeasurement() {
      if (!enabled) { container.dataset.measurement = 'disabled'; return; }
      const privacy = root.Shopify && root.Shopify.customerPrivacy;
      const allowed = ['analyticsProcessingAllowed', 'marketingAllowed', 'saleOfDataAllowed'].every(name => privacy && typeof privacy[name] === 'function' && privacy[name]() === true);
      if (!allowed) {
        container.dataset.measurement = 'consent-blocked';
        if (tagStarted) adsCommand('consent', 'update', {ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied', analytics_storage:'denied'});
        return;
      }
      if (!tagStarted) {
        tagStarted = true;
        adsCommand('consent', 'default', {ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied', analytics_storage:'denied'});
        adsCommand('consent', 'update', {ad_storage:'granted', ad_user_data:'granted', ad_personalization:'denied', analytics_storage:'denied'});
        adsCommand('js', new Date());
        adsCommand('config', 'AW-822240134', {send_page_view:false, allow_google_signals:false, allow_ad_personalization_signals:false, allow_enhanced_conversions:false});
        const script = root.document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-822240134&l=nhsAdsDataLayer';
        script.onload = () => { container.dataset.tagLoaded = 'true'; };
        script.onerror = () => { container.dataset.tagLoaded = 'false'; };
        root.document.head.appendChild(script);
      } else {
        adsCommand('consent', 'update', {ad_storage:'granted', ad_user_data:'granted', ad_personalization:'denied', analytics_storage:'denied'});
      }
      container.dataset.measurement = 'ready';
      if (confirmed && !confirmed.test && !conversionQueued && pendingRecord(JSON.stringify(confirmed), Date.now(), root.location.pathname)) {
        conversionQueued = true;
        adsCommand('event', 'conversion', {send_to:'AW-822240134/1YSnCPDRl_8cEIbHiYgD', transaction_id:confirmed.id});
        root.dataLayer = root.dataLayer || [];
        root.dataLayer.push({event:'nhs_inquiry_submitted', event_id:confirmed.id, campaign:CAMPAIGN});
        container.dataset.measurement = 'inquiry-queued';
      }
    }
    if (container.dataset.errors === 'true') remove(key);
    if (container.dataset.posted === 'true') {
      const pending = pendingRecord(get(key), Date.now(), root.location.pathname);
      remove(key);
      const success = container.querySelector('[data-nhs-success]');
      if (success) { success.hidden = false; success.focus(); }
      confirmed = pending;
    }
    if (enabled) {
      root.document.addEventListener('visitorConsentCollected', syncMeasurement);
      if (root.Shopify && typeof root.Shopify.loadFeatures === 'function') {
        root.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => {
          if (!error) syncMeasurement();
        });
      }
    }
    syncMeasurement();
    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      if (preview) {
        event.preventDefault();
        const message = container.querySelector('[data-nhs-preview-result]');
        if (message) { message.hidden = false; message.focus(); }
        return;
      }
      set(key, JSON.stringify({id, created:Date.now(), path:root.location.pathname, test}));
    });
  }
  const scan = () => root.document.querySelectorAll('[data-nhs-staging-tracking]').forEach(init);
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', scan); else scan();
  root.document.addEventListener('shopify:section:load', scan);
})(typeof window === 'undefined' ? null : window);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
